document.addEventListener('DOMContentLoaded', () => {
    const mobileToggle = document.querySelector('.header-mobile-toggle');
    const mobileNavDrawer = document.querySelector('.mobile-nav-drawer');
    const headerWrapper = document.querySelector('.header-wrapper');
    const overlay = document.querySelector('.mobile-menu-overlay');
    const closeBtn = document.querySelector('.mobile-nav-close');

    // Mobile Menu Logic
    const toggleMenu = (isOpen) => {
        if (isOpen) {
            mobileNavDrawer.classList.add('is-active');
            overlay.classList.add('is-active');
            if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
        } else {
            mobileNavDrawer.classList.remove('is-active');
            overlay.classList.remove('is-active');
            if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        }
    };

    // Handle standard mobile toggle
    if (mobileToggle) {
        mobileToggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const isExpanded = mobileNavDrawer && mobileNavDrawer.classList.contains('is-active');
            toggleMenu(!isExpanded);
        });
    }

    // Handle bottom nav menu triggers
    const bottomNavTriggers = document.querySelectorAll('.js-mobile-menu-trigger');
    bottomNavTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const isExpanded = mobileNavDrawer && mobileNavDrawer.classList.contains('is-active');
            toggleMenu(!isExpanded);
        });
    });

    // Handle bottom nav search triggers
    const bottomNavSearchTriggers = document.querySelectorAll('.js-search-trigger');
    bottomNavSearchTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Priority 1: Direct API call to the modal
            const searchModal = document.getElementById('search-modal');
            if (searchModal && typeof searchModal.showDialog === 'function') {
                searchModal.showDialog();
                return;
            }

            // Priority 2: Try to find the search modal trigger button
            const searchModalTrigger = document.querySelector('.search-modal__button') ||
                document.querySelector('search-button button') ||
                document.querySelector('details-modal.header__search summary') ||
                document.querySelector('.header__icon--search') ||
                document.querySelector('.header-search-icon') ||
                document.querySelector('details-modal summary[aria-haspopup="dialog"]') ||
                document.querySelector('.header-icons .header-icon[href*="/search"]');

            if (searchModalTrigger) {
                searchModalTrigger.click();
            } else {
                // Fallback: redirect to search page
                window.location.href = '/search';
            }
        });
    });

    // Handle bottom nav cart triggers
    const bottomNavCartTriggers = document.querySelectorAll('.js-cart-trigger');
    bottomNavCartTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Priority 1: Direct API call to the cart drawer component
            const cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer) {
                if (typeof cartDrawer.open === 'function') {
                    cartDrawer.open(trigger);
                } else {
                    customElements.whenDefined('cart-drawer-component').then(() => {
                        if (typeof cartDrawer.open === 'function') {
                            cartDrawer.open(trigger);
                        }
                    });
                }
                return;
            }

            // Priority 2: Try to find the header cart icon button (which triggers the drawer)
            const cartIconTrigger = document.querySelector('.header-cart-icon') ||
                document.querySelector('[data-testid="cart-drawer-trigger"]');

            if (cartIconTrigger) {
                cartIconTrigger.click();
            } else {
                // Fallback: redirect to cart page
                window.location.href = '/cart';
            }
        });
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', () => toggleMenu(false));
    }

    if (overlay) {
        overlay.addEventListener('click', () => toggleMenu(false));
    }

    // Mega Menu Hover Logic for Transparent Header
    const menuItemsWithMega = document.querySelectorAll('.header-menu-item--has-mega, .header-menu-item'); // Target all items to be safe

    menuItemsWithMega.forEach(item => {
        item.addEventListener('mouseenter', () => {
            if (headerWrapper) headerWrapper.classList.add('is-hovered');
        });

        item.addEventListener('mouseleave', () => {
            if (headerWrapper) headerWrapper.classList.remove('is-hovered');
        });
    });

    // Sticky Header Logic
    const handleScroll = () => {
        if (!headerWrapper) return;

        const scrollY = window.scrollY || document.documentElement.scrollTop;

        if (scrollY > 10) {
            headerWrapper.classList.add('is-scrolled');
        } else {
            headerWrapper.classList.remove('is-scrolled');
        }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check

    // Announcement Bar & Top Bar Height Positioning Logic
    const updateHeaderPosition = () => {
        const announcementBar = document.querySelector('.announcement-bar');
        const topBar = document.querySelector('.header-top-bar');
        let totalHeight = 0;

        if (announcementBar) {
            totalHeight += announcementBar.getBoundingClientRect().height;
        }

        if (topBar) {
            totalHeight += topBar.getBoundingClientRect().height;
        }

        // Update CSS variable
        document.documentElement.style.setProperty('--announcement-bar-height', `${totalHeight}px`);

        // We rely on CSS var(--announcement-bar-height) for positioning the transparent header.
        // No need to manually set style.top here, as it causes issues when scrolling back up.
    };

    // Use ResizeObserver to watch for height changes
    const resizeObserver = new ResizeObserver(() => {
        updateHeaderPosition();
        checkMenuOverflow();
    });

    // Observe body to catch any layout shifts, and announcement bar specifically
    resizeObserver.observe(document.body);
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
        resizeObserver.observe(announcementBar);
    }
    const topBar = document.querySelector('.header-top-bar');
    if (topBar) {
        resizeObserver.observe(topBar);
    }

    // More Menu Logic
    const checkMenuOverflow = () => {
        const nav = document.querySelector('.header-nav');
        const menu = document.querySelector('.header-menu');
        const moreItem = document.querySelector('.header-menu-item--more');
        const moreList = document.querySelector('.header-menu-more-list');

        if (!nav || !menu || !moreItem || !moreList) return;

        // Reset: Move all items back to main menu first
        const movedItems = Array.from(moreList.children);
        movedItems.reverse().forEach(item => {
            menu.insertBefore(item, moreItem);
        });
        moreItem.style.display = 'none';

        // If mobile, stop here (we just wanted to reset)
        if (window.innerWidth < 990) return;

        // Calculate available space
        // We need to account for the "More" button width AND the custom button width
        const moreButtonWidth = 100;
        const customButton = document.querySelector('.header-custom-button');
        let customButtonWidth = 0;

        if (customButton && getComputedStyle(customButton).display !== 'none') {
            customButtonWidth = customButton.offsetWidth + 20; // Width + margin
        }

        const navWidth = nav.clientWidth;

        // Get all menu items except the "More" button
        const menuItems = Array.from(menu.children).filter(item => item !== moreItem);

        let currentWidth = 0;
        let overflowIndex = -1;

        // Calculate total width of items
        for (let i = 0; i < menuItems.length; i++) {
            currentWidth += menuItems[i].offsetWidth + 25; // 25px gap

            // The limit is the total nav width minus:
            // 1. The custom button width (always reserved if visible)
            // 2. The "More" button width (reserved unless we are at the very last item and it fits perfectly)

            const spaceNeededForMore = (i === menuItems.length - 1) ? 0 : moreButtonWidth;
            const limit = navWidth - customButtonWidth - spaceNeededForMore;

            if (currentWidth > limit) {
                overflowIndex = i;
                break;
            }
        }

        if (overflowIndex !== -1) {
            moreItem.style.display = 'block';

            // Move items starting from overflowIndex to the More menu
            for (let i = overflowIndex; i < menuItems.length; i++) {
                moreList.appendChild(menuItems[i]);
            }
        }
    };

    // Initial calls
    updateHeaderPosition();
    checkMenuOverflow();

    // Fallback for slow loading assets
    window.addEventListener('load', () => {
        updateHeaderPosition();
        checkMenuOverflow();
    });
});
